<!-- Fixed badge in every corner; full warning revealed on hover/focus. z above header (40) & podcast player (50). -->
@for (corner of corners; track corner.key) {
  <div class="group fixed z-[60]" [ngClass]="corner.badge">
    <span
      class="flex w-fit cursor-pointer items-center gap-1.5 rounded-full border border-amber-600 bg-amber-300 px-3 py-1 text-xs font-bold uppercase tracking-wide text-amber-950 shadow-md"
      tabindex="0"
      role="note"
      aria-label="Demo environment — outbound integrations are live: real Zoom webinars are created, the Brevo test account sends real emails to real recipients, and RSS entries are created but not distributed. Only use INTERNAL email addresses. If you are unsure, check the side effects first."
      [attr.data-testid]="'demo-environment-badge-' + corner.key">
      <svg
        class="h-3.5 w-3.5 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path
          d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      Demo
      <!-- Pointer/hand hint so it reads as interactive (hover/tap for detail). -->
      <svg
        class="h-3.5 w-3.5 flex-shrink-0 opacity-80"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path d="M22 14a8 8 0 0 1-8 8" />
        <path d="M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2" />
        <path d="M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1" />
        <path d="M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10" />
        <path d="M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15" />
      </svg>
    </span>

    <div
      class="pointer-events-none absolute w-72 scale-95 rounded-md border border-amber-600 bg-amber-50 p-3 text-xs leading-snug text-amber-950 opacity-0 shadow-lg transition-all duration-150 group-hover:scale-100 group-hover:opacity-100 group-focus-within:scale-100 group-focus-within:opacity-100"
      [ngClass]="corner.tip"
      role="tooltip"
      [attr.data-testid]="'demo-environment-tooltip-' + corner.key">
      <p class="font-bold uppercase tracking-wide">Outbound integrations are LIVE</p>
      <p class="mt-1">This is a demo/staging deployment, but actions still trigger real side effects:</p>
      <ul class="mt-1 list-disc space-y-0.5 pl-4">
        <li>Real Zoom <span class="font-semibold">webinars</span> are created</li>
        <li>The Brevo (test) account sends <span class="font-semibold">real emails</span> to real recipients</li>
        <li>RSS entries are created but <span class="font-semibold">not distributed</span></li>
      </ul>
      <p class="mt-2 font-semibold">Only use INTERNAL email addresses.</p>
      <p class="mt-1">If you are unsure, check the side effects first.</p>
    </div>
  </div>
}
